(function () {
  function init(root) {
    root.querySelectorAll('[data-ct-slider]').forEach((container) => {
      if (container.dataset.ctInit) return;
      container.dataset.ctInit = 'true';

      const before = container.querySelector('[data-ct-slider-before]');
      const handle = container.querySelector('[data-ct-slider-handle]');
      let dragging = false;

      function setPosition(clientX) {
        const rect = container.getBoundingClientRect();
        const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
        const percent = (x / rect.width) * 100;
        before.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
        handle.style.left = percent + '%';
      }

      function onMove(e) {
        if (!dragging) return;
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        setPosition(clientX);
      }
      function onUp() {
        dragging = false;
      }

      container.addEventListener('mousedown', (e) => {
        dragging = true;
        setPosition(e.clientX);
      });
      container.addEventListener('touchstart', (e) => {
        dragging = true;
        setPosition(e.touches[0].clientX);
      }, { passive: true });

      window.addEventListener('mousemove', onMove);
      window.addEventListener('touchmove', onMove, { passive: true });
      window.addEventListener('mouseup', onUp);
      window.addEventListener('touchend', onUp);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
